import { makeStyles } from '@pickupp/ui/styles'
import qs from 'qs'
import React, { useContext, useEffect } from 'react'

import { BROWSER, MERCHANT_PORTAL } from '~/config'
import Page from '~/src/components/Page'
import { LocaleContext } from '~/src/contexts'
import { useIsMobile } from '~/src/hooks'

import styles from './styles'

const useStyles = makeStyles(styles)

const TrackingPage = () => {
  const classes = useStyles()

  const { language } = useContext(LocaleContext)
  const isMobile = useIsMobile()

  const paramsString = BROWSER ? window.location.search.substring(1) : ''
  const params = qs.parse(paramsString)
  const orderNumber = params.orderNumber || ''
  const trackingPage = `${MERCHANT_PORTAL}/${language}/tracking?orderNumber=${orderNumber}`

  useEffect(() => {
    window.addEventListener('message', (message) => {
      if (message.data === 'startLiveChat') {
        window.$chatwoot.toggle('open')
      }
    })
  }, [])

  return (
    <Page>
      <iframe
        title="tracking"
        scrolling={isMobile}
        src={trackingPage}
        className={classes.iframe}
        allowFullScreen
      />
    </Page>
  )
}

export default TrackingPage
